// Libs
import React, { useContext, useEffect, useMemo, useState } from 'react';
import Upload, { UploadProps } from 'antd/lib/upload';
import { Select } from 'antd';
import moment from 'moment';

// Own Libs
import { Button, ColumnProps, FormContext, FormInput, FormItem, Icon, Table } from '@digital/ui';

//Api

//Files
import { Visibility } from '../Visibility';

//Utils
import { dateTimeFormat } from '@app/helpers/dateTimeFormats';
import TipoOptions, { IArquivo, IArquivoActions, IUploadFile } from '@app/types/core.types';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import { compareText } from '@app/helpers/comparators';
import { EStatusArquivo } from '@app/enums/EStatusArquivo';


interface IProps {
    filename?: string;
    accept?: string;
    label?: string;
    url?: string;
    disabled?: boolean;
    type?: string;
    className?: string;
    idDoComponente: string;
    name?: string;
    showData?: boolean;
    onGetArquivos?: () => Promise<IArquivo[]>;
    arquivoActions?: IArquivoActions;
    hasSetFileName?: boolean;
    switchOptionsStatusArquivo?: TipoOptions[];
    tablePagination: boolean;

    visible?: boolean;
    showUpload?: boolean;
    showTableData?: boolean;
}

interface IStatusArquivoProps {
    filename: string;
    statusArquivoId: string;
}

export const UploadMultipleTableTmp = ({
    filename,
    accept,
    label,
    url,
    disabled = false,
    type,
    className,
    idDoComponente,
    name,
    showData = false,
    onGetArquivos,
    arquivoActions,
    hasSetFileName = false,
    switchOptionsStatusArquivo,
    tablePagination = true,

    visible = true,
    showUpload = true,
    showTableData = true,
}: IProps) => {
    const { formProps } = useContext(FormContext);

    const buttonLabel = label ? label : 'Adicionar arquivo';
    const [listFileC, setListFileC] = useState<IUploadFile[]>([]);
    const [listFileTemp, setListFileTemp] = useState<IUploadFile[]>([]);
    const [statusSelected, setStatusSelected] = useState<IStatusArquivoProps[]>([]);

    const formName = name ? name : 'files';

    // const [optionsStatusArquivo, setOptionsStatusArquivo] = useState<TipoOptions[]>([]);

    // console.log('formProps', formProps);

    const loadArquivos = async () => {
        onGetArquivos && onGetArquivos()
            .then((arquivos) => {
                const aa = arquivos.map(m => {
                    return {
                        uid: m.id,
                        name: m.nome,
                        status: m.status,
                        statusArquivoId: m.statusArquivoId,
                        hasActions: false,
                    } as IUploadFile;
                });
                setListFileTemp(aa);
                setListFileC(aa);
            });
    };

    // const loadOptionsStatusArquivo = async () => {
    //     onGetStatusArquivo && onGetStatusArquivo()
    //         .then(opts => {
    //             setOptionsStatusArquivo(opts);
    //         });
    // }

    useEffect(() => {
        loadArquivos();
        // loadOptionsStatusArquivo();
        // setStatusSelected([]);
    }, []);

    const remove = (record: any) => {
        var list = listFileC.filter(c => c.uid !== record.uid && isObjNotEmpty(c.uid));
        setListFileC(list);
    };

    const updateFile = (list: any) => {
        setListFileC(list.fileList);
    };

    useEffect(() => {
        //feito o Upload
        var arquivosUpload = listFileC.map(c => c.originFileObj);
        if (isObjNotEmpty(arquivosUpload)) {
            formProps && formProps.setFieldValue(formName, arquivosUpload);
            formProps && formProps.setFieldValue("statusArquivos", statusSelected);
        }

        //vindo da API
        formProps && formProps.setFieldValue(formName + "Api", listFileTemp);

    }, [listFileC, listFileTemp]);

    const uploadProps: UploadProps = {
        action: '',
        multiple: true,
        type: 'select',
        accept: accept ? accept : '.xlsx, .xls, .png, .doc, .docx, .ppt, .pptx,.txt,.pdf',
        onRemove: _ => {
            formProps && formProps.setFieldValue(formName, null);
        },
        beforeUpload: file => {
            return false;
        },
        headers: {
            authorization: 'authorization-text',
        },
    };

    const handleSelectStatusArquivo = (value: any, record: IUploadFile) => {
        var list = listFileC.filter(c => c.uid !== record.uid && isObjNotEmpty(c.uid));
        record.statusArquivoId = value; //vtGetOptionTextByValue(switchOptionsStatusArquivo || [], vtParseBooleanFromString(value));
        list.push(record);
        setListFileC(list);

        var arquivosUpload = listFileC.map(c => c.originFileObj);

        if (isObjNotEmpty(arquivosUpload) && record.name) {
            var sTmp: IStatusArquivoProps[] = statusSelected.filter(c => c.filename !== record.name);
            var s = {
                filename: record.name,
                statusArquivoId: value
            } as IStatusArquivoProps;
            sTmp.push(s);
            setStatusSelected(sTmp);
        }
    };

    const columns = () => {
        const columns: ColumnProps<IUploadFile>[] = [];

        columns.push({
            title: 'Nome',
            dataIndex: 'name',
            sortOrder: 'ascend'
        });

        if (showData) {
            columns.push({
                title: 'Inclusão',
                width: '20%',
                render: (text, record) => moment().format(dateTimeFormat)
            });
        }

        if (switchOptionsStatusArquivo && isObjNotEmpty(switchOptionsStatusArquivo)) {
            columns.push({
                title: 'Status',
                width: '20%',
                // dataIndex: 'status',
                render: (text, record) => {
                    return (
                        <Select
                            style={{ width: "100%" }}
                            placeholder="Selecione uma opção"
                            value={record.statusArquivoId != EStatusArquivo.AGUARDANDO_ENVIO.id && record.statusArquivoId}
                            onSelect={(value) => handleSelectStatusArquivo(value, record)}
                            disabled={disabled}
                        >
                            {switchOptionsStatusArquivo.map((item: any, idx: any) => (
                                <Select.Option key={item.value}>{item.text}</Select.Option>
                            ))}
                        </Select>
                    );
                }
            });
        }

        if (!disabled) {
            columns.push({
                title: 'Ações',
                width: '10%',
                render: (text, record) => {

                    if (record.hasActions == false) {
                        return <></>;
                    }

                    return <Button onClick={() => remove(record)} disabled={disabled} ><Icon name='commons-trash' /></Button>;
                }
            });
        }


        return columns;
    };

    const tabela = useMemo(() => (
        <Table
            className='upload-multiple-table'
            pagination={tablePagination ? { defaultPageSize: 5 } : false}
            dataSource={listFileC.sort((a, b) => compareText(a.name, b.name))}
            columns={columns()}
        />
    ), [listFileC, formProps]);

    return (
        <Visibility visible={visible}>
            <Visibility
                visible={hasSetFileName}
                isFragment={false}
            >
                <FormItem name="filename" span={12}>
                    <FormInput
                        name="filename"
                        label={'Nome do arquivo'}
                        placeholder={'Nome do arquivo'}
                        onChange={(e) => {
                            if (formProps) {
                                formProps.setFieldValue('filename', e.target.value);
                            }
                        }}
                        disabled={disabled}
                    />
                </FormItem>
            </Visibility>

            <FormItem name={formName} span={12}>
                <Visibility visible={showUpload}>
                    <Upload id={idDoComponente}
                        fileList={listFileC}
                        onChange={e => updateFile(e)}
                        showUploadList={false}
                        className={className}
                        disabled={disabled}
                        name={formName}
                        {...uploadProps}>
                        <Visibility visible={!disabled}                        >
                            <Button
                                id='mrn-button-upload-inserirAnexo'
                                type={type ? type : 'link'}
                                icon="ui-upload">
                                {buttonLabel}
                            </Button>
                        </Visibility>
                    </Upload>
                </Visibility>

                <Visibility visible={showTableData}>
                    {tabela}
                </Visibility>
            </FormItem>

        </Visibility>
    );
};